import { render, staticRenderFns } from "./SMSTemplateList.vue?vue&type=template&id=7a08dcda&scoped=true&"
import script from "./SMSTemplateList.vue?vue&type=script&lang=js&"
export * from "./SMSTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a08dcda",
  null
  
)

export default component.exports